<template>
  <div v-sticky="{ zIndex: 99, stickyTop: 146}" class="jin-pc-sidebar">
    <ul class="jin-pc-sidebar-warp">
      <li v-for="item in headInfo" :key="item.title" class="jin-pc-sidebar-item" :class="{'jin-pc-sidebar-item-active' : item.title === active}">
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'

export default {
  directives: {
    'sticky': VueSticky
  },
  props: {
    active: {
      type: String,
      default: ''
    },
    headInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-pc {
    &-sidebar {
      padding: 40px 0 0 40px;
      height: 300px;

      &-item {
        padding: 12px 27px 12px 0;
        font-size: 14px;
        color: #787b8a;
        line-height: 20px;
        position: relative;

        &::after {
          content: '';
          display: block;
          height: 100%;
          width: 2px;
          background: #e8e8ea;
          position: absolute;
          right: 0;
          top: 0;
          transition: all 0.3s;
        }

        &-active {
          font-weight: 500;
          color: #3d4351;

          &::after {
            background: #3d4351;
          }
        }
      }
    }
  }
}
</style>
